<template>
    <div class="twoColumnText">
        <div class="indexBg">
            <div class="indexContainer">
                <el-divider class="indexTitle" v-if="val.title">
                    <div class="indexTitleMain">
                        <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                        <h4>{{val.summary}}</h4>
                    </div>
                </el-divider>
                <div>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" v-for="(item,index) in newTextlist" :key="index">
                            <div class="newTextlist" @click="rowClick(item)">
                                <div class="title">
                                    <span>{{ item.date }}</span>
                                    <p>{{ item.year }}</p>
                                </div>
                                <div class="text">
                                    <p>{{ item.title }}</p>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="24" v-if="val.more = 1">
                            <el-button class="more" round @click="handleShow">{{val.moreText}}</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { filterTime } from '@/common/js/common.js'
export default {
  props: {
    val: {}
  },
    data(){
        return{
            newTextlist:[],
            moduleId:''
        }
    },
    created() {
      this.newTextlist = this.val.modules ? this.val.modules[0].articles : [];
      for(let i of this.newTextlist){
            i.releaseTime = filterTime(i.releaseTime, 'time')
            let arr = i.releaseTime.trim().split(" ");
            i.date = arr[0].split("-")[2];
            i.year = arr[0].split("-")[0] + '-'  + arr[0].split("-")[1];
      }
      this.moduleId = this.val.moduleId;

    },
    methods:{
        handleShow() {
            let routerURL = this.$router.resolve({
                name: 'INNERPAGER',
                query: {
                    model: this.val.module.model,
                    moduleId:this.moduleId,
                    id: this.val.module.id,
                    level: 2,
                    type: Number(this.val.module.model) === 1 ? 2 : 1,
                    languageId: this.val.module.languageId
                },
            });
            window.open(routerURL.href,'_blank')
        },
        rowClick(row){
            let routerPath = this.$router.resolve({
              name: 'ARTICLEDETAIL',
              query: {
                languageId: this.$route.query.languageId,
                model: this.$route.query.model,
                moduleId:this.moduleId,
                modelId: this.$route.query.id,
                level: this.$route.query.level,
                type: this.$route.query.type,
                id: row.id
              }
            });
            window.open(routerPath.href,'_blank')
        },
    },
    watch: {
      val(val) {
        this.newTextlist = this.val.modules ? this.val.modules[0].articles : [];
       }
    }

}
</script>
<style lang="less" scoped>
.twoColumnText{
    .indexBg{
        background: #f7f7f7;
        width: 100%;
        .el-divider__text{
        background: #f7f7f7;
        }
    }
    .newTextlist{
        border-top:1px solid #f1f1f1;
        padding: 15px 0;
        cursor: pointer;
        .title{
            background: #fff;
            border-radius: 4px;
            width: 80px;
            height: 80px;
            font-size: 24px;
            overflow: hidden;
            color: #d11a2e;
            box-sizing: border-box;
            font-weight: bold;
            text-align: center;
            padding-top:10px;
            float: left;
            span{
                display: inline-block;
                width: 100%;

            }
            p{
                font-size: 16px;
                margin: 0;
                line-height: 30px;
                font-weight: normal;
                width: 100%;
            }
        }
        .text{
            font-size: 16px;
            margin: 0;
            line-height: 24px;
            text-align: left;
            box-sizing: border-box;
            height: 80px;
            flex: 1;
            padding-left:10px;
            overflow: hidden;
            font-weight: bold;
            p{
                display: -webkit-box;
                -webkit-box-orient: vertical;
                box-sizing: border-box;
                -webkit-line-clamp:3;
                text-overflow: ellipsis;
                height: 70px;
                margin:0 10px;
                overflow: hidden;

            }
        }
    }
    .newTextlist:hover{
        .text{
            color: #d11a2e;
        }
    }
    .el-col:nth-child(1) .newTextlist,.el-col:nth-child(2) .newTextlist{
        border:none;
    }
    .more{
        padding:10px 50px;
        color: #d11a2e;
        box-shadow: 1px 1px 2px rgba(0, 0, 0,0.2);
        margin-bottom: 50px;
        margin-top: 20px;
    }
    .more:hover{
        background:#f7f7f7;
        border: 1px solid #DCDFE6;
    }
    .el-button:hover{
        border:1px solid #eee;
        color: #d11a2e;
    }
    .el-button:focus{
        color: #d11a2e;
        border-color: #ccc;
        background-color: #f7f7f7;
    }
    @media only screen and (min-width: 768px){
        .newTextlist{
            .text{
                font-weight: normal;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/item/patch9.vue